/**
 * Composant ErrorMessage
 *
 * Affiche un message d'erreur avec icône et bouton retry
 * Design moderne avec fond rouge clair
 *
 * @param {string} message - Message d'erreur à afficher
 * @param {Function} onRetry - Callback appelé lors du clic sur "Réessayer"
 */

import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

const ErrorMessage = ({ message = 'Une erreur est survenue', onRetry }) => {
  return (
    <div className="flex items-center justify-center min-h-[400px] w-full p-6">
      <div className="max-w-md w-full">
        {/* Card d'erreur */}
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          {/* Icône et titre */}
          <div className="flex items-center gap-3 mb-3">
            <AlertCircle className="w-6 h-6 text-red-600 flex-shrink-0" />
            <h3 className="text-lg font-semibold text-red-900">
              Erreur
            </h3>
          </div>

          {/* Message d'erreur */}
          <p className="text-sm text-red-700 mb-4 leading-relaxed">
            {message}
          </p>

          {/* Bouton retry */}
          {onRetry && (
            <button
              onClick={onRetry}
              className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg
                       hover:bg-red-700 transition-colors duration-200 text-sm font-medium
                       focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            >
              <RefreshCw className="w-4 h-4" />
              Réessayer
            </button>
          )}
        </div>

        {/* Message d'aide optionnel */}
        <p className="mt-4 text-xs text-gray-500 text-center">
          Si le problème persiste, veuillez contacter le support technique.
        </p>
      </div>
    </div>
  );
};

export default ErrorMessage;
